export enum EnumModFrete {
    CONTRATACAO_REMETENTE = 0,
    CONTRATACAO_DESTINATARIO = 1,
    CONTRATACAO_TERCEIROS = 2,
    PROPRIO_REMETENTE = 3,
    PROPRIO_DESTINATARIO = 4,
    SEM_TRANSPORTE = 9
}